// src/services/labtestService.js
import apiClient from "./apiClient";
import axios from "axios";

const API_URL = `/labtests`; // Use relative path since apiClient has baseURL

// Helper function to get environment variable
const getEnvVar = (key, defaultValue = null) => {
  if (typeof window !== 'undefined' && window.env && typeof window.env === 'object' && window.env[key]) {
    return window.env[key];
  }
  if (process.env && process.env[key]) {
    return process.env[key];
  }
  return defaultValue;
};

const BACKEND_URL = getEnvVar('REACT_APP_BACKEND_URL', 'http://localhost:8080/api');

export const createLabtests = async (invoice) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.post(API_URL, invoice);
    return response.data;
  } catch (error) {
    console.error("Error creating Labtests:", error);
    throw error;
  }
};

export const getLabtestsList = async () => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching Labtests:", error);
    throw error;
  }
};

export const getLabTestById = async (id) => {
    try {
        // apiClient will automatically add organizationId as query param via interceptor
        const response = await apiClient.get(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching lab test by ID:", error);
        throw error;
    }
};

export const updateLabtest = async (id, payload) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.put(`${API_URL}/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating Labtest:", error);
    throw error;
  }
};

// Base table functions (not organization-specific)
export const getAllLabTests = async () => {
  try {
    // Fetch from base lab test table (not organization-specific)
    // Use direct axios call to bypass apiClient's organizationId interceptor
    console.log(`[getAllLabTests] Fetching lab tests from base lab test table...`);
    
    const token = localStorage.getItem("token");
    const apiUrl = `${BACKEND_URL}${API_URL}`;
    
    const response = await axios.get(apiUrl, {
      // Bust intermediate caches so edits appear without a full browser refresh
      params: { _t: Date.now() },
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    const data = response.data;
    console.log(`[getAllLabTests] ✅ Fetched ${Array.isArray(data) ? data.length : 0} lab tests from base table`);
    return data;
  } catch (error) {
    console.error("[getAllLabTests] ❌ Error fetching lab tests:", error);
    throw error;
  }
};

export const createLabTestInBaseTable = async (reqData) => {
  try {
    // Create lab test in base lab test table (not organization-specific)
    // Use direct axios call to bypass apiClient's organizationId interceptor
    console.log(`[createLabTestInBaseTable] Creating lab test in base lab test table...`);
    
    const token = localStorage.getItem("token");
    const apiUrl = `${BACKEND_URL}${API_URL}`;
    
    const response = await axios.post(apiUrl, reqData, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    console.log(`[createLabTestInBaseTable] ✅ Successfully created lab test in base table`);
    return response.data;
  } catch (error) {
    console.error("[createLabTestInBaseTable] ❌ Error creating lab test:", error);
    throw error;
  }
};

export const updateLabTestInBaseTable = async (id, reqData) => {
  try {
    // Update lab test in base lab test table (not organization-specific)
    // Use direct axios call to bypass apiClient's organizationId interceptor
    console.log(`[updateLabTestInBaseTable] Updating lab test ${id} in base lab test table...`);
    
    const token = localStorage.getItem("token");
    const apiUrl = `${BACKEND_URL}${API_URL}/${id}`;
    
    const response = await axios.put(apiUrl, reqData, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    console.log(`[updateLabTestInBaseTable] ✅ Successfully updated lab test in base table`);
    return response.data;
  } catch (error) {
    console.error("[updateLabTestInBaseTable] ❌ Error updating lab test:", error);
    throw error;
  }
};

export const getLabTestByIdFromBaseTable = async (id) => {
    try {
        // Fetch lab test from base table (not organization-specific)
        // Use direct axios call to bypass apiClient's organizationId interceptor
        console.log(`[getLabTestByIdFromBaseTable] Fetching lab test ${id} from base lab test table...`);
        
        const token = localStorage.getItem("token");
        const apiUrl = `${BACKEND_URL}${API_URL}/${id}`;
        
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        });
        
        console.log(`[getLabTestByIdFromBaseTable] ✅ Successfully fetched lab test from base table`);
        return response.data;
    } catch (error) {
        console.error("[getLabTestByIdFromBaseTable] ❌ Error fetching lab test by ID:", error);
        throw error;
    }
};